import {urls} from '../constants';

export interface LogService {
  info(...args: any[]): void;
  warn(...args: any[]): void;
  error(...args: any[]): void;
  sendError(message: string): void;
}

export const log: LogService = {

  /* tslint:disable:no-console */
  info: (...args: any[]) => console.info(...args),
  warn: (...args: any[]) => console.warn(...args),
  error: (...args: any[]) => console.error(...args),
  /* tslint:enable:no-console */

  sendError(message: string) {
    const errorData = new FormData();
    errorData.append('url', window.location.href);
    errorData.append('message', message);

    fetch(urls.ERROR_LOGGING, {
      mode: 'no-cors',
      method: 'post',
      body: errorData,
    });
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/log.ts